import { Form, Modal, Button, FloatingLabel } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import './feedbackmodal.css';

const FeedBackModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{ color: '#ec008c' }}>
          Your Feedback
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <div className="feedBackModal-title">
          <h4>Your Feedback</h4>
          <IoClose className='feedbackModal-cancel-btn' size={24} onClick={props.onHide} />

        </div>
        <Form className="form-modal">
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Control className="shadow-none" type="text" placeholder="Name*" />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Control className="shadow-none" type="email" placeholder="E-mail*" />
          </Form.Group>
          <Form.Group className="form-modal" controlId="formTextarea">
            <Form.Control as="textarea" className="shadow-none" rows={3} style={{ height: '100px' }} placeholder='Write your feedback...' />
          </Form.Group>
        </Form>
        <div className="feedbackModal-footer">
          <Button className="button-color feedback-submit-btn" onClick={props.onHide}>Submit</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FeedBackModal;
